import { render, staticRenderFns } from "./DownloadClaimForm.vue?vue&type=template&id=1d7a54f6"
import script from "./DownloadClaimForm.vue?vue&type=script&lang=js"
export * from "./DownloadClaimForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports